
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-svg icon-person",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"var(--iconColor, --current-color-500)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.118 9.334H4.883c-.535 0-1.04.097-1.513.291a4.07 4.07 0 00-1.24.83 3.642 3.642 0 00-.82 1.23A3.79 3.79 0 001 13.217v1.55c0 .242.07.434.21.573.14.14.33.21.574.21.23 0 .416-.07.556-.21.14-.14.21-.33.21-.574v-1.55c0-.656.224-1.209.674-1.658.45-.45 1.003-.675 1.659-.675h6.235c.656 0 1.209.225 1.658.675.45.45.675 1.002.675 1.659v1.55c0 .242.07.434.21.573.14.14.325.21.556.21.243 0 .434-.07.574-.21.14-.14.21-.33.21-.574v-1.55a3.79 3.79 0 00-.31-1.53 3.642 3.642 0 00-.82-1.231 4.07 4.07 0 00-1.24-.83 3.947 3.947 0 00-1.513-.291zM8 7.766c.547 0 1.058-.097 1.532-.292a3.955 3.955 0 001.23-.83c.346-.346.623-.756.83-1.23.194-.474.291-.984.291-1.531 0-.547-.097-1.057-.291-1.531a3.955 3.955 0 00-.83-1.23 3.955 3.955 0 00-1.23-.83A3.995 3.995 0 008 0C7.453 0 6.943.097 6.47.292a3.955 3.955 0 00-1.23.83 3.955 3.955 0 00-.83 1.23 3.995 3.995 0 00-.292 1.53c0 .548.098 1.058.292 1.532.207.474.483.884.83 1.23.346.347.756.624 1.23.83.474.195.984.292 1.531.292zM8 1.55c.657 0 1.21.224 1.66.674.449.45.674 1.003.674 1.659 0 .656-.225 1.21-.675 1.659-.45.45-1.002.674-1.659.674-.656 0-1.209-.224-1.659-.674-.45-.45-.674-1.003-.674-1.66 0-.655.225-1.208.674-1.658.45-.45 1.003-.674 1.66-.674z"}})])
          )
        }
      }
    